<app-toast></app-toast>
<app-generate-electricity-jsondialog [toast]="toast"
    [reloadCallbackFunction]="reloadCallbackFunctionElectricity"></app-generate-electricity-jsondialog>
<app-generate-gas-jsondialog [toast]="toast"
    [reloadCallbackFunction]="reloadCallbackFunctionGas"></app-generate-gas-jsondialog>
<app-delete-confirmation-dialog title="{{ 'shared.delete_this' | transloco}}"></app-delete-confirmation-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="4"></app-admin-navigation>
    </div>

    <!-- Electricity -->
    <div class="w-full h-auto border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'shared.electricity'
                    | transloco }} {{ 'admin.json_generator' | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <div class="m-5 flex flex-wrap gap-2 justify-between items-center">
            <div class="w-[150px] h-[50px]">
                <app-custom-button buttonText="{{ 'admin.generate' | transloco }}" leadingIcon="assets/icons/add.svg"
                    backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                    hoverBorderColor="hover:border-primary-1200" hoverBackgroundColor="hover:bg-primary-1200"
                    (buttonClick)="openGenerateElectricityDialog()"></app-custom-button>
            </div>

            <div class="flex flex-col gap-2">
                <div class="w-[300px]">
                    <app-custom-dropdown [options]="filterDropdownOptions"
                        [(selectedOption)]="selectedFilterDropdownElectricity"
                        (selectedOptionChange)="applySelectedFilterElectricity()"></app-custom-dropdown>
                </div>
                <div class="w-[300px] h-[50px]">
                    <app-custom-button
                        buttonText="{{ 'admin.upload_json' | transloco}} {{ 'shared.electricity' | transloco}}"
                        leadingIcon="assets/icons/upload.svg"
                        (buttonClick)="triggerElectricityFileInput()"></app-custom-button>
                    <input type="file" #elFileInput accept=".json" (change)="onElectricityFileSelected($event)" hidden
                        multiple>
                </div>
            </div>
        </div>

        <!-- History Table -->
        <div class="w-full flex flex-col gap-2 p-5">
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[300px] max-h-[700px] overflow-y-auto rounded-[16px]">
                <table class="table w-full">
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">#</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.date' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'archive.overview.file_name' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'invoice.labels.period' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">ID</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'invoice.labels.number' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                                'archive.overview.action' |
                                transloco }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let inv of electricityInvoices; let i = index">
                            <tr>
                                <td class="border-b border-border px-4 py-4">{{ i + 1 }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.processed_at | isoDate }}
                                </td>
                                <td class="border-b border-border px-4 py-4">{{ electricityResponse[i].file_name || ''
                                    }}
                                </td>
                                <td class="border-b border-border px-4 py-4">{{ inv.data.invoice_data.for_period ||
                                    '' | isoPeriod }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.id ||
                                    '' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.data.invoice_data.invoice_number ||
                                    '' }}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center justify-end">
                                        <!-- Edit -->
                                        <button (click)="editElectricityInvoice(i)"
                                            title="{{ 'settings.button.edit' | transloco }}"
                                            class="p-1 rounded hover:bg-secondary-200">
                                            <img src="assets/icons/edit.svg"
                                                alt="{{ 'settings.button.edit' | transloco }}" class="w-6 h-6" />
                                        </button>

                                        <!-- Delete -->
                                        <button title="{{ 'shared.delete' | transloco }}"
                                            (click)="removeElectricityInvoice(i)">
                                            <svg width="24" height="24" viewBox="0 0 50 50">
                                                <circle cx="25" cy="25" r="24" fill="#FF0000" />
                                                <image href="assets/icons/delete.svg" x="12" y="12" height="25px"
                                                    width="25px" />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="loadedElectricityInvoices.length > 0 && !loadMoreHiddenElectricity">
                            <td colspan="7">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadElectricityHistoryNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Gas -->
    <div class="w-full h-auto border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-secondary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'shared.gas'
                    | transloco }} {{ 'admin.json_generator' | transloco }}
                </p>
                <div class="h-[2px] w-full bg-secondary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <div class="m-5 flex flex-wrap gap-2 justify-between items-center">
            <div class="w-[150px] h-[50px]">
                <app-custom-button buttonText="{{ 'admin.generate' | transloco }}" leadingIcon="assets/icons/add.svg"
                    backgroundColor="bg-secondary" textColor="text-white" borderColor="border-secondary"
                    hoverBorderColor="hover:border-secondary-1200" hoverBackgroundColor="hover:bg-secondary-1200"
                    (buttonClick)="openGenerateGasDialog()"></app-custom-button>
            </div>

            <div class="flex flex-col gap-2">
                <div class="w-[300px]">
                    <app-custom-dropdown [options]="filterDropdownOptions"
                        [(selectedOption)]="selectedFilterDropdownGas"
                        (selectedOptionChange)="applySelectedFilterGas()"></app-custom-dropdown>
                </div>
                <div class="w-[300px] h-[50px]">
                    <app-custom-button buttonText="{{ 'admin.upload_json' | transloco}} {{ 'shared.gas' | transloco}}"
                        leadingIcon="assets/icons/upload.svg" (buttonClick)="triggerGasFileInput()"></app-custom-button>
                    <input type="file" #gasFileInput accept=".json" (change)="onGasFileSelected($event)" hidden
                        multiple>
                </div>
            </div>
        </div>

        <!-- History Table -->
        <div class="w-full flex flex-col gap-2 p-5">
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[300px] max-h-[700px] overflow-y-auto rounded-[16px]">
                <table class="table w-full">
                    <thead class="bg-secondary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">#</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.date' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'archive.overview.file_name' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'invoice.labels.period' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">ID</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'invoice.labels.number' |
                                transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                                'archive.overview.action' |
                                transloco }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let inv of gasInvoices; let i = index">
                            <tr>
                                <td class="border-b border-border px-4 py-4">{{ i + 1 }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.processed_at | isoDate }}
                                </td>
                                <td class="border-b border-border px-4 py-4">{{ gasResponse[i].file_name || ''
                                    }}
                                </td>
                                <td class="border-b border-border px-4 py-4">{{ inv.data.invoice_data.for_period ||
                                    '' | isoPeriod }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.id ||
                                    '' }}</td>
                                <td class="border-b border-border px-4 py-4">{{ inv.data.invoice_data.invoice_number ||
                                    '' }}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center justify-end">
                                        <!-- Edit -->
                                        <button (click)="editGasInvoice(i)"
                                            title="{{ 'settings.button.edit' | transloco }}"
                                            class="p-1 rounded hover:bg-secondary-200">
                                            <img src="assets/icons/edit.svg"
                                                alt="{{ 'settings.button.edit' | transloco }}" class="w-6 h-6" />
                                        </button>

                                        <!-- Delete -->
                                        <button title="{{ 'shared.delete' | transloco }}" (click)="removeGasInvoice(i)">
                                            <svg width="24" height="24" viewBox="0 0 50 50">
                                                <circle cx="25" cy="25" r="24" fill="#FF0000" />
                                                <image href="assets/icons/delete.svg" x="12" y="12" height="25px"
                                                    width="25px" />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="loadedGasInvoices.length > 0 && !loadMoreHiddenGas">
                            <td colspan="7">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadGasHistoryNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>